<template>
  <div>
    <tabs
      :niveau="2"
      :links="tabList"
      :current-tab="tab"
      :level="2"
      @changeView="tab = $event"
      mode="emitter"
      class="has-background-light is-border-bottom"></tabs>
    <table
      class="table is-fullwidth is-last-fixed-medium is-marginless has-cells-vcentered"
      v-if="salesToDisplay && salesToDisplay.length">
      <thead>
        <tr class="is-size-6">
          <th>Statut</th>
          <th>Programme</th>
          <th>Référence du Lot</th>
          <th>Référence de l'ADV</th>
          <th v-if="isAdmin">
            Promoteur
          </th>
          <th v-if="displaySeller">
            Vendeur
          </th>
          <th v-if="displayContact">
            Contact
          </th>
          <th>Date {{ dateLabel }}</th>
        </tr>
      </thead>
      <tbody class="is-size-6">
        <tr
          v-for="(s, n) in salesToDisplay"
          :key="'tr' + n">
          <td class="has-text-centered">
            <span
              class="dot tooltip"
              :class="s.status|optionsDotClass"
              :data-tooltip="optionStatus[s.status].label"></span>
          </td>
          <td>
            <router-link
              v-if="s.program"
              :to="{name: 'ProgramVue', params: {id: s.program.pk}}">
              {{ s.program.name }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td class="is-cell-hoverable">
            <router-link
              v-if="s.lot"
              :to="{name: 'LotVue', params: {id: s.lot.pk}}">
              {{ s.lot.ref }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td class="is-cell-hoverable">
            <router-link
              v-if="s.ref"
              :to="{name: 'AdvInfos', params: {id: s.pk}}">
              {{ s.ref }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td v-if="isAdmin">
            <span v-if="s.promoteur">{{ s.promoteur.name }}</span>
            <span v-else>-</span>
          </td>
          <td
            class="is-cell-hoverable"
            v-if="displaySeller">
            <router-link
              v-if="s.user"
              :to="{name: 'UserVue', params: {id: s.user.pk}}">
              {{ s.user.last_name }} {{ s.user.first_name }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td
            class="is-cell-hoverable"
            v-if="displayContact">
            <router-link
              v-if="s.contact"
              :to="{name: 'ContactVue', params: {id: s.contact.pk}}">
              {{ s.contact.last_name }} {{ s.contact.first_name }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td class="is-narrow">
            {{ s.created_on | prettyDate }}
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="is-padding"
      v-else>
      <span></span>
      {{ noneTab }} à afficher
    </div>
  </div>
</template>

<script>
import DefaultValues from '@/mixins/DefaultValues.js'
import { mapGetters } from 'vuex'

export default {
  name: 'SalesLightList',
  mixins: [DefaultValues],
  props: {
    sales: {
      type: Array,
      require: true
    }
  },
  data () {
    return {
      tab: 'PRE_RESERVED',
      noneTab: 'Aucune pré-réservation'
    }
  },
  computed: {
    ...mapGetters(['isAdmin']),
    /**
       * tabs list
       * @returns {array}
       */
    tabList () {
      return [
        { label: `Pré-Réservations (${this.preReservedSales.length})`, link: 'PRE_RESERVED' },
        { label: `Réservations (${this.reservedSales.length})`, link: 'RESERVED' },
        { label: `Actes (${this.soldSales.length})`, link: 'SOLD' },
        { label: `Annulations (${this.canceledSales.length})`, link: 'CANCELED' }
      ]
    },
    /**
       * display seller
       * @returns {boolean}
       */
    displaySeller () {
      return !this.$route.path.includes('users')
    },
    /**
       * display contact
       * @returns {boolean}
       */
    displayContact () {
      return !this.$route.path.includes('contacts')
    },
    /**
       * array of pre_reserved sales
       * @returns {array}
       */
    preReservedSales () {
      let okStatus = ['pre_reserved']
      return this.sales.filter(x => okStatus.includes(x.status))
    },
    /**
       * array of reserved sales
       * @returns {array}
       */
    reservedSales () {
      let okStatus = ['reserved']
      return this.sales.filter(x => okStatus.includes(x.status))
    },
    /**
       * array of sold sales
       * @returns {array}
       */
    soldSales () {
      let okStatus = ['sold']
      return this.sales.filter(x => okStatus.includes(x.status))
    },
    /**
       * array of canceled sales
       * @returns {array}
       */
    canceledSales () {
      let okStatus = ['canceled']
      return this.sales.filter(x => okStatus.includes(x.status))
    },
    /**
       * sales to display by tab
       * @returns {array}
       */
    salesToDisplay () {
      if (this.tab === 'PRE_RESERVED') {
        return this.preReservedSales
      } else if (this.tab === 'RESERVED') {
        return this.reservedSales
      } else if (this.tab === 'SOLD') {
        return this.soldSales
      } else {
        return this.canceledSales
      }
    },
    /**
       * date label
       * @returns {string}
       */
    dateLabel () {
      if (this.tab === 'PRE_RESERVED') {
        return 'de pré-réservation'
      } else if (this.tab === 'RESERVED') {
        return 'de réservation'
      } else if (this.tab === 'SOLD') {
        return 'de vente'
      } else {
        return 'd\'annulation'
      }
    }
  },
  watch: {
    tab (v) {
      if (v === 'PRE_RESERVED') {
        this.noneTab = 'Aucune pré-réservation'
      } else if (v === 'RESERVED') {
        this.noneTab = 'Aucune réservation'
      } else if (v === 'SOLD') {
        this.noneTab = 'Aucun acte'
      } else {
        this.noneTab = 'Aucune annulation'
      }
    }
  }
}
</script>
